var _g, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgObservatoryColor = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 83,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158 83",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M86.95 45.016l3.808-3.844 5.618 5.67-3.686 3.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M76 48v-4.014a1.84 1.84 0 0 1 .692-1.418 2.199 2.199 0 0 1 1.612-.466 18.872 18.872 0 0 1 17.15 15.778 1.8 1.8 0 0 1-.508 1.482 2.142 2.142 0 0 1-1.54.638H89.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F18686",
    d: "M88 60c0-6.628-5.372-12-12-12s-12 5.372-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M61.5 60h29a2 2 0 0 1 2 2v19h-33V62a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M88 60c0-6.628-5.372-12-12-12s-12 5.372-12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    d: "M94.414 44.86L92.66 43.1a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M94.414 44.86L92.66 43.1a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    d: "M72.5 67.5h7a1 1 0 0 1 1 1V81h-9V68.5a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M72.5 67.5h7a1 1 0 0 1 1 1V81h-9V68.5a1 1 0 0 1 1-1zM56.5 81h39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0D8",
    d: "M42 23c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM117 20c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM154 70c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 59.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 47.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 26.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 73.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 32.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 39.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 54.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 57.5,
    r: 1.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })))));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 83,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 158 83",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: fill,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M86.95 45.016l3.808-3.844 5.618 5.67-3.686 3.72"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M76 48v-4.014a1.84 1.84 0 0 1 .692-1.418 2.199 2.199 0 0 1 1.612-.466 18.872 18.872 0 0 1 17.15 15.778 1.8 1.8 0 0 1-.508 1.482 2.142 2.142 0 0 1-1.54.638H89.5"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F18686",
    d: "M88 60c0-6.628-5.372-12-12-12s-12 5.372-12 12"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F8",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M61.5 60h29a2 2 0 0 1 2 2v19h-33V62a2 2 0 0 1 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M88 60c0-6.628-5.372-12-12-12s-12 5.372-12 12"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    d: "M94.414 44.86L92.66 43.1a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M94.414 44.86L92.66 43.1a4.74 4.74 0 0 1 0-6.672l.066-.066a1.182 1.182 0 0 1 1.672-.012l.012.012 6.74 6.8a1.21 1.21 0 0 1 0 1.702 4.74 4.74 0 0 1-6.704.028l-.032-.032z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#74B0F4",
    d: "M72.5 67.5h7a1 1 0 0 1 1 1V81h-9V68.5a1 1 0 0 1 1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1,
    d: "M72.5 67.5h7a1 1 0 0 1 1 1V81h-9V68.5a1 1 0 0 1 1-1zM56.5 81h39"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD0D8",
    d: "M42 23c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM117 20c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137zM154 70c.581 0 1.053.509 1.053 1.137l-.001 1.81h1.812c.627 0 1.136.471 1.136 1.053 0 .581-.509 1.053-1.136 1.053l-1.812-.001v1.812c0 .627-.47 1.136-1.052 1.136-.581 0-1.053-.509-1.053-1.136v-1.812h-1.81c-.628 0-1.137-.47-1.137-1.052 0-.582.509-1.053 1.136-1.053h1.811v-1.81c0-.628.472-1.137 1.053-1.137z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 59.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 47.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 26.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 73.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5,
    cy: 32.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 8.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.5,
    cy: 39.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 54.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 57.5,
    r: 1.5,
    fill: "#CAD0D8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(109 63)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 67)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "#CAD0D8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1,
    fill: "#F4F6F8"
  })))));
});
export default SvgObservatoryColor;
export const raw = __webpack_public_path__ + "static/media/observatory-color.784c9bad8e9d87009f9c3dc3a425908c.svg";